<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select> -->
                <el-input v-model="name" placeholder="请输入编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float:right" type="primary" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                stripe
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="index" width="55" align="center"></el-table-column>
                <el-table-column prop="code_name" label="所属模块" align="center" width="180" sortable></el-table-column>
                <el-table-column prop="billtype_no" label="编号" align="center" sortable></el-table-column>
                <el-table-column prop="billtype_name" label="名称" align="center" sortable></el-table-column>

                <el-table-column label="是否默认" align="center" width="120">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isdefault" :active-value="1" :inactive-value="0" @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="是否启用" align="center" width="120">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" align="center"></el-table-column>
                <el-table-column prop="build_name" :label="$t('common.creator')" align="center"></el-table-column>
                <el-table-column prop="build_date" :label="$t('common.createTime')" align="center" width="180" sortable></el-table-column>
                <el-table-column prop="modify_name" :label="$t('common.modifier')" align="center"></el-table-column>
                <el-table-column prop="modify_date" :label="$t('common.modifyTime')" align="center" width="180" sortable></el-table-column>
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="scope">
                        <el-button type="primary" plain @click="handleEdit(scope.row)" v-if="perData.allow_edit == 1">{{ $t('common.edit') }}</el-button>
                        <el-button type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 添加类别 -->
        <el-dialog title="添加" :visible.sync="addData.isshow">
            <el-form label-width="100px">
                <el-form-item label="编号">
                    <el-input v-model="addData.data.billtype_no" @blur="sure_billtype_no"></el-input>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input v-model="addData.data.billtype_name"></el-input>
                </el-form-item>
                <el-form-item label="所属模块">
                    <el-select v-model="addData.data.code" placeholder="请选择" style="width:100%">
                        <el-option v-for="(item, index) in pullData.bill_mode" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否默认">
                    <el-switch style="margin-left: 5px" v-model="addData.data.isdefault" active-value="1" inactive-value="0"> </el-switch>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-switch style="margin-left: 5px" v-model="addData.data.status" active-value="1" inactive-value="0"> </el-switch>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input type="textarea" v-model="addData.data.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancalClear()">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="editData.isshow">
            <el-form label-width="100px">
                <el-form-item label="编号">
                    <el-input v-model="editData.data.billtype_no" @blur="sure_billtype_no" :disabled="editData.isshow"></el-input>
                </el-form-item>
                <el-form-item label="类别名称">
                    <el-input v-model="editData.data.billtype_name"></el-input>
                </el-form-item>
                <el-form-item label="所属模块">
                    <el-select v-model="editData.data.code" placeholder="请选择" style="width:100%">
                        <el-option v-for="(item, index) in pullData.bill_mode" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否默认">
                    <el-switch style="margin-left: 5px" v-model="editData.data.isdefault" active-value="1" inactive-value="0"> </el-switch>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-switch style="margin-left: 5px" v-model="editData.data.status" active-value="1" inactive-value="0"> </el-switch>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input type="textarea" v-model="editData.data.remark"></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否显示">
                    <el-radio v-model="editData.data.status" label="0">否</el-radio>
                    <el-radio v-model="editData.data.status" label="1">是</el-radio>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancalClear()">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
import {
    apibilltypeList,
    apisetDetail,
    apiaddBillType,
    apiupdateBilltype,
    apideleteBilltype,
    apiCurrentPermisson,
    apibilltypePull
} from '@/request/api';
export default {
    name: 'basetable',
    data() {
        return {
            pullData: [],
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            pageTotal: 0,
            typeNo: '',
            selectList: [],
            editData: { isshow: false, scope: null, index: 0, data: {} },
            addData: { isshow: false, scope: null, index: 0, data: {} }
        };
    },
    created() {
        this.getData();
        this.getPermission();
        this.getPull();
    },
    activated() {
        this.getData();
        this.getPermission();
    },
    methods: {
        getPull() {
            apibilltypePull().then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        // 不能有中文
        sure_billtype_no() {
            if (this.addData.data.billtype_no != '') {
                var myreg = /^[A-Za-z0-9]+$/;
                if (myreg.test(this.addData.data.billtype_no)) {
                } else {
                    this.$message.error('请输入正确编号,只能输入字母和数字');
                    this.addData.data.billtype_no = '';
                }
            }
            if (this.editData.data.billtype_no != '') {
                var myreg = /^[A-Za-z0-9]+$/;
                if (myreg.test(this.editData.data.billtype_no)) {
                } else {
                    this.$message.error('请输入正确编号,只能输入字母和数字');
                    this.editData.data.billtype_no = '';
                }
            }
        },
        // 启用按钮
        tableDatastates(row) {
            this.editData.data = row;
            this.saveEdit();
        },
        // 获取列表信息
        getData() {
            this.$load.show();
            apibilltypeList({
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.name
            }).then(res => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
            this.$load.close();
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '114'
            }).then(res => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addData.isshow = true;
            this.addData.data = {};
        },
        saveAdd() {
            let data = this.addData.data;
            apiaddBillType(this.addData.data).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '添加成功', type: 'success' });
                    this.addData.isshow = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apideleteBilltype(row).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作----------------------------------------------------------------------------------------------------
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function(item, index, array) {
                arr.push(item.type_no);
            });
            this.selectList = arr;
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        handleEdit(row) {
            this.editData.isshow = true;
            this.editData.data = row;
        },
        // 保存编辑
        saveEdit() {
            let data = this.editData.data;
            apiupdateBilltype(this.editData.data).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '修改成功', type: 'success' });
                    this.editData.isshow = false;
                } else {
                    this.$message.error(res.data.info);
                }
                this.getData();
            });
        },
        cancalClear() {
            this.addData.isshow = false;
            this.editData.isshow = false;
            this.getData();
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
